// src/pages/Contact.jsx
import { useState } from "react";

const CASE_TYPES = [
  "Baby Formula NEC Lawsuits",
  "RoundUp Cancer Lawsuits",
  "Chemical Hair Relaxers and Straighteners Cancer",
  "Paraquat Herbicide Lawsuits",
  "Lung Cancer Asbestos Lawsuit",
  "PFAS Water Contamination Lawsuits",
  "Los Angeles Wildfire",
  "Oxbryta Lawsuits",
  "Bard PowerPort Catheter Lawsuits",
  "Hernia Mesh Lawsuits",
  "Ozempic and Wegovy Lawsuits",
  "Depo Provera Lawsuits",
  "Suboxone Lawsuit",
  "Auto Accident and Personal Injury Lawsuits",
  "Social Security Disability Benefits (SSDI) Applications",
  "Birth Injury Lawyers",
  "Video Game Addiction Lawsuits",
  "LDS Mormon Church Abuse Lawsuit",
  "Roblox & Discord Child Abuse Lawsuit",
  "Rideshare Abuse and Assault Lawsuits",
];

export default function Contact() {
  const [sent, setSent] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    // TODO: replace with your Formspree endpoint or API call
    // Example:
    // await fetch("https://formspree.io/f/xxxxxxx", { method: "POST", body: new FormData(e.target) });
    setSent(true);
  };

  return (
    <main className="min-h-screen bg-white">
      {/* Hero */}
      <section className="bg-[#F7F3EC]">
        <div className="max-w-screen-2xl mx-auto px-6 py-16">
          <h1 className="text-3xl md:text-5xl font-extrabold tracking-tight text-[#0A2540]">
            Contact Us
          </h1>
          <p className="mt-3 text-[#0A2540]/80 max-w-2xl">
            Fast, confidential help—no obligations and no upfront costs. This
            form does not create an attorney-client relationship; a partner firm
            will review eligibility and contact you.
          </p>
        </div>
      </section>

      {/* Form + Info */}
      <section className="py-14">
        <div className="max-w-screen-2xl mx-auto px-6 grid md:grid-cols-3 gap-8">
          {/* Form */}
          <div className="md:col-span-2">
            <div className="rounded-2xl bg-white ring-1 ring-black/10 p-6">
              {!sent ? (
                <form
                  onSubmit={onSubmit}
                  className="grid grid-cols-1 md:grid-cols-2 gap-4"
                >
                  <div>
                    <label className="text-sm font-medium text-[#0A2540]">
                      First Name*
                    </label>
                    <input
                      name="firstName"
                      required
                      className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2 outline-none focus:ring-2 focus:ring-[#C89B3C]"
                      placeholder="John"
                    />
                  </div>
                  <div>
                    <label className="text-sm font-medium text-[#0A2540]">
                      Last Name*
                    </label>
                    <input
                      name="lastName"
                      required
                      className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2 outline-none focus:ring-2 focus:ring-[#C89B3C]"
                      placeholder="Doe"
                    />
                  </div>
                  <div>
                    <label className="text-sm font-medium text-[#0A2540]">
                      Email*
                    </label>
                    <input
                      type="email"
                      name="email"
                      required
                      className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2 outline-none focus:ring-2 focus:ring-[#C89B3C]"
                      placeholder="you@example.com"
                    />
                  </div>
                  <div>
                    <label className="text-sm font-medium text-[#0A2540]">
                      Mobile Number*
                    </label>
                    <input
                      name="phone"
                      required
                      className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2 outline-none focus:ring-2 focus:ring-[#C89B3C]"
                      placeholder="+1 ..."
                    />
                  </div>
                  <div className="md:col-span-2">
                    <label className="text-sm font-medium text-[#0A2540]">
                      Case Type
                    </label>
                    <select
                      name="caseType"
                      className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2 outline-none focus:ring-2 focus:ring-[#C89B3C]"
                      defaultValue=""
                    >
                      <option value="" disabled>
                        Select a case type…
                      </option>
                      {CASE_TYPES.map((c) => (
                        <option key={c} value={c}>
                          {c}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="md:col-span-2">
                    <label className="text-sm font-medium text-[#0A2540]">
                      Message*
                    </label>
                    <textarea
                      name="message"
                      required
                      rows={5}
                      className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2 outline-none focus:ring-2 focus:ring-[#C89B3C]"
                      placeholder="Tell us briefly about your situation…"
                    />
                  </div>
                  <div className="md:col-span-2">
                    <label className="inline-flex items-start gap-2 text-sm text-[#0A2540]/80">
                      <input type="checkbox" required className="mt-1" />
                      <span>
                        I agree to be contacted and understand this is not legal
                        advice or a guarantee of representation.
                      </span>
                    </label>
                  </div>
                  <div className="md:col-span-2">
                    <button
                      type="submit"
                      className="inline-flex items-center rounded-full px-6 py-3 font-semibold text-white bg-[#C89B3C] hover:bg-[#B8872D] transition"
                    >
                      Submit
                    </button>
                  </div>
                </form>
              ) : (
                <div className="text-center py-12">
                  <div className="text-2xl font-semibold text-[#0A2540]">
                    Thanks! 🎉
                  </div>
                  <p className="mt-2 text-[#0A2540]/80">
                    We’ve received your details. A partner firm will review
                    eligibility and reach out.
                  </p>
                </div>
              )}
            </div>
          </div>

          {/* Info */}
          <aside>
            <div className="rounded-2xl bg-white ring-1 ring-black/10 p-6">
              <h3 className="font-semibold text-[#0A2540]">What to expect</h3>
              <ul className="mt-3 space-y-2">
                {[
                  "Private review within minutes",
                  "No upfront fees",
                  "Clear eligibility guidance",
                ].map((t) => (
                  <li key={t} className="flex items-start gap-2">
                    <span className="mt-2 h-1.5 w-1.5 rounded-full bg-[#C89B3C]" />
                    <span className="text-sm leading-6 text-[#0A2540]/80">
                      {t}
                    </span>
                  </li>
                ))}
              </ul>

              <div className="mt-6 text-xs text-[#0A2540]/60">
                MassTortPlaintiffs is not a law firm. Submitting this form does
                not create an attorney-client relationship. Partner firms
                determine eligibility and representation.
              </div>
            </div>
          </aside>
        </div>
      </section>
    </main>
  );
}
